export default __webpack_public_path__ + "static/media/marketing-estrategico.49fbe86c.jpg";